// pub.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface Publicite {
  id?: number;
  titre?: string;
  imageUrl: string;
  description?: string;
  lien?: string;
  pathimage: string;
  href?: string;
  pathvideo?: string; // Added pathvideo property
}

@Injectable({
  providedIn: 'root',
})
export class PubService {
  private baseUrl = 'https://mon-compte.educanet.pro';

  constructor(private http: HttpClient) {}

  /**
   * Récupère les articles publicitaires pour une organisation et position données
   * @param orgname Nom de l'organisation (ex: Pubeducanet)
   * @param position Position de la pub (ex: StorieWeb)
   * @param page Numéro de page (ex: 1)
   * @param size Nombre d'éléments par page (ex: 10)
   */
  getPublicites(
    orgname: string,
    position: string,
    page: number,
    size: number
  ): Observable<Publicite[]> {
    const url = `${this.baseUrl}/mobile/delice/pageArticlePublicitaire/${orgname}/${position}/${page}/${size}`;

    return this.http.get<Publicite[]>(url).pipe(
      tap({
        next: (response) => {
          // Log specific parts of the response if it has the expected structure
          if (response && typeof response === 'object') {
            if ('results' in response) {
              if ((response as any).results?.articlePublicitaire) {
              }
            } else if (Array.isArray(response)) {
            }
          }
        },
        error: (error) => {},
      })
    );
  }
}
